import GenOTPBlock from "../../components/GenOTPBlock";
import HeaderPage from "../../components/HeaderPage";
import HexagonComponent from "../../components/HexagonComponent";
import styles from "./genotppage.module.css";

export default function GenOTPPage() {
    return (
        <div className={`container-fluid ${styles.page}`}>
            <HeaderPage />
            <div className={`row my-5 ${styles.logoandsignupBlock}`}>
                <div
                    className={`col-lg-4 col-xl-4 col-md-6 col-sm-4 ${styles.hexagonlogoContainer}`}
                >
                    <HexagonComponent />
                </div>
                <div
                    className={`col-lg-4 col-xl-4 col-md-6 col-sm-3 ${styles.genOTPContainer}`}
                >
                    <GenOTPBlock />
                </div>
            </div>
        </div>
    );
}